export const getComponentOfType = (components, type) => {
  if (!components || !type) {
    return false;
  }

  return components.find(
    (component) =>
      component.internal &&
      component.internal.type &&
      component.internal.type === type
  );
};

export const containsComponentOfType = (components, type) => {
  if (!components || !type) {
    return false;
  }

  return components.some(
    (component) =>
      component.internal &&
      component.internal.type &&
      component.internal.type === type
  );
};

export const getRemoveMarginBottom = (component) => {
  if (!component) {
    return false;
  }

  return !!component.removeMarginBottom;
};
